import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import useCrmInteraction from 'api/hooks/useCrmInteraction';
import { BREAKDOWN_OPTIONS } from './breakdownDimensions';

const unitForView = (currentView) => (currentView === 'Day' ? 'day' : currentView === 'Week' ? 'week' : 'month');

const useCallInteractionsForCell = ({ cell, breakdownBy, currentView }) => {
  const { queryCrmInteractions } = useCrmInteraction();
  const [interactions, setInteractions] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useRef(null);
  fetchData.current = async (signal) => {
    if (!cell) return;
    setIsLoading(true);
    try {
      const filters = [
        { field: 'dateTime', operator: 'date_gte', value: cell.date },
        { field: 'dateTime', operator: 'date_lt', value: dayjs(cell.date).add(1, unitForView(currentView)).format('YYYY-MM-DD') },
      ];
      if (cell.bucket != null) {
        const filterField = BREAKDOWN_OPTIONS.find((option) => option.value === breakdownBy)?.filterField;
        if (filterField) {
          filters.push({ field: filterField, operator: 'str_eq', value: `${cell.bucket}` });
        }
      }
      const result = await queryCrmInteractions({ signal, filters, pageNumber: 1, pageSize: 50 });
      if (result) setInteractions(result.hits ?? []);
    } catch (error) {}
    setIsLoading(false);
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchData.current(controller.signal);
    return () => controller.abort('Component unmounted.');
  }, [cell?.date, cell?.bucket, breakdownBy, currentView]);

  return { interactions, isLoading };
};

export default useCallInteractionsForCell;
